export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    getSearchFields: state => state.searchFields,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDetailsHeaderFields: state => state.detailsHeaderFields,
    getDetailsFormActions: state => state.detailsFormActions,
    getDetailsActions: state => state.detailsActions,
    getDetailsRowActions: state => state.detailsRowActions,
    getDetailsDataTableOptions: state => state.detailsDataTableOptions,
    isDetailsFormOpen: state => state.detailsFormIsOpen,
    isDetailsGridOpen: state => state.detailsGridIsOpen,

}
